import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-team-stacking/actions';

class IncludeDefenseman extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setTeamDefensemanIsIncluded(this.props.team, isChecked, this.props.stackNumber));
    }

    render() {
        const {team, stackNumber, stacking} = this.props;
        const isChecked = stacking.isTeamDefensemanIncluded(team, stackNumber);

        return (
            <div className="checkbox">
                <label>
                    <input type="checkbox" onChange={(e) => ::this.onChange(e.target.checked)} checked={isChecked} />
                    Include D in stacks
                </label>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(IncludeDefenseman);
